export default __webpack_public_path__ + "static/media/landing-banner.215ead69.jpeg";